/* eslint-disable max-classes-per-file */
/* eslint-disable class-methods-use-this */
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { FIELD_ENDPOINTS, FIELDS_URL } from 'SharedDir/backend/endpoints/fields';
import { FieldStatus } from 'SharedDir/constants/fields';
import { ChangeStatusFrom, Field, FieldType } from 'SharedDir/declarations/fields';
import { Nullable, WithRelations } from 'SharedDir/declarations/shared';

export default class FieldsApiClass extends SimpleApi<
Required<WithRelations<Field>>,
Nullable<Field, 'id'>
> {
  constructor() {
    super(FIELDS_URL);
  }

  public TypesApi() {
    return new (class extends SimpleApi<FieldType, FieldType> {})(`${this.url}/types`);
  }

  /**
   * Получаем ВСЕ утвержденные поля
   *
   * @static
   * @returns {Promise<Array<Required<Field>>>>}
   * @memberof FieldsApi
   */
  public async getAllApproved<T extends { isFillable?: boolean; withFieldTypeParams?: boolean }>(
    params?: T
  ) {
    return this.getAll({
      descending: false,
      sortBy: 'name',
      status: FieldStatus.approved,
      ...params,
    });
  }

  async changeStatus(id: number, form: ChangeStatusFrom) {
    const { data } = (await http({
      ...FIELD_ENDPOINTS.CHANGE_STATUS(id),
      data: form,
    })) as AxiosResponse<WithRelations<Field>>;
    return data;
  }

  async sendCheck(id: number) {
    const { data } = (await http(FIELD_ENDPOINTS.SEND_CHECK(id))) as AxiosResponse<
    WithRelations<Field>
    >;
    return data;
  }
}
